import { AxiosResponse, AxiosStatic } from "axios";

export interface IGroupsApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

export interface IGroupsApi {
  getEditableByRelativeTo: (accountId: string, organizationId: string) => Promise<AxiosResponse>;
}

export default class GropusApi implements IGroupsApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: IGroupsApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public getEditableByRelativeTo = (accountId: string, organizationId: string) => {
    return this.axios.get(
      `${this.apiRoot}/collections/groups/editableBy/${accountId}/relativeToOrg/${organizationId}`,
      {
        params: { activeUser: accountId },
      }
    );
  };
}
